import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Input } from '@pwc/appkit-react/lib/Input';
import {
  formatExpirationInputDate,
  minExpirationDate,
  maxExpirationDate,
} from '../dateHelpers';

class ExpirationDateCellRenderer extends PureComponent {
  static propTypes = {
    disabled: PropTypes.bool.isRequired,
    checkedClientsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
    editableClientId: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    data: PropTypes.shape({
      clientId: PropTypes.number,
      expirationDate: PropTypes.string,
    }).isRequired,
  };

  onChange = value => {
    this.props.onChange(
      this.props.data.clientId,
      value
    );
  };

  onKeyDown = e => e.preventDefault();

  render() {
    const {
      disabled,
      checkedClientsIds,
      editableClientId,
      readOnly,
      data,
    } = this.props;

    const isEditable = editableClientId === data.clientId && checkedClientsIds.includes(data.clientId)
      && !disabled;
    const formatDate = data.expirationDate ? formatExpirationInputDate(data.expirationDate) : '';

    return (
      <Input
        type="date"
        class={'expiration-date-cell-renderer'}
        onChange={this.onChange}
        value={formatDate}
        disabled={readOnly || !isEditable}
        min={minExpirationDate}
        max={maxExpirationDate}
        onKeyDown={this.onKeyDown}
      />
    );
  }
}

export default () => props => <ExpirationDateCellRenderer {...props} />; // eslint-disable-line react/display-name
